var map = {
	"./0_desc.png": 4082,
	"./1_desc.png": 9532,
	"./2_desc.png": 2518,
	"./3_desc.png": 7258,
	"./4_desc.png": 3145,
	"./5_desc.png": 1410,
	"./6_desc.png": 1818,
	"./7_desc.png": 5900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6877;